module.exports = __webpack_public_path__ + "media/images/team__torquegc-b0fed92d2f7a73ed89ef2ec772601e71.png";